exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".arrow[data-v-323fe56e]{border-color:#fff transparent;border-style:solid;border-width:13px 13px 0;bottom:-13px}@media (orientation:landscape){.ipad-position[data-v-323fe56e]{margin-right:124px}}@media (orientation:portrait){.ipad-position[data-v-323fe56e]{margin-right:129px}}", ""]);

// exports
